import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.OfferDetail || initialState;

const makeOfferSelectField = (field) =>
  createSelector(reducerState, (offerState) => offerState[field]);

export { reducerState, makeOfferSelectField };
